import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import { useFormik } from "formik";
import ReactSelect from "../../UI/ReactSelect";
import * as Yup from "yup";
import axios from "axios";
import InputMask from "react-input-mask";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  partnerId: "",
  partnerCityId: "",

};

export default function Create(props) {
  const {
    show,
    onHide,
    onMerchants,
    skip,
    take,
    sortField,
    orderBy,
    cities,
    setCities,
    // loadOptionsPartner,
    partners,

  } = props;
  const [isError, setIsError] = useState("");


  const [partnersOption, setPartnersOption] = React.useState({});
  function handleChangePartners(value) {
    setPartnersOption(value);
    formik.setFieldValue("partnerId", value.value);
  }


  const CreateSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().required("Email is required")
      .email("Wrong email format. E.g. jhon.doe@example.com")
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
    ,
    phoneNumber: Yup.string().required("Phone number is required"),

    partnerId: Yup.string().required("Partner Id is required"),
    partnerCityId: Yup.string().required("Partner City Id is required"),

  });

  const [phoneNumber, setPhoneNumber] = React.useState("");

  const [citiesOption, setCitiesOption] = React.useState(null);
  // const [partnersOption, setPartnersOption] = React.useState({});

  // function handleChangePhoneNumber(e) {
  //   setPhone(e.target.value);
  // }


  const partnersOptions = partners.map((suggestion) => ({
    value: suggestion.id,
    label: suggestion.name,
  }));


  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };




  const onPostMerchant = (values, resetForm, setSubmitting) => {
    const merchant = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      // phone: values.phone,
      phoneNumber: values.phoneNumber,
      partnerId: values.partnerId,
      partnerCityId: values.partnerCityId,
    };
    axios
      .post(`${process.env.REACT_APP_API_URL}partner/merchant`, merchant, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then((res) => {
        onMerchants(skip, take, sortField, orderBy);
        setSubmitting(false);
        resetForm();
        onHide();
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostMerchant(values, resetForm, setSubmitting);
    },
  });
  const { setFieldValue } = formik;


  function handleChangePartners(value) {
    setPartnersOption(value);
    formik.setFieldValue("partnerId", value?.value);
    setFieldValue("partnerId", value?.value);



    axios
      .get(`${process.env.REACT_APP_API_URL}partner/cities/${value?.value}`)
      .then((res) => {
        const displayTypesNames = res?.data?.data?.map(({ id, address }) => ({
          value: id,
          label: address,
        }));
        setCities(displayTypesNames);
      });
    setCitiesOption(null);
  }


  // const citiesOptions = cities.map((suggestion) => ({
  //   value: suggestion.id,
  //   label: suggestion.name,
  // }));

  // const partnersOptions = partners.map((suggestion) => ({
  //   value: suggestion.id,
  //   label: suggestion.name,
  // }));




  function handleChangeCities(value) {
    setCitiesOption(value);

    setFieldValue("partnerCityId", value?.value);

  }


  useEffect(() => {
    setIsError("");
    setPhoneNumber("");
    if (!show) {
      setCitiesOption("")
      setPartnersOption("");

    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="edit"
      centered
      className="modal-right pr-0"
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="edit">Create</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="col-12 pl-4 pr-4">
            <div className="d-none">{phoneNumber}</div>
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="firstName"
                    label="First Name"
                    placeholder="First Name"
                    className="w-100"
                    error={getInputClasses("firstName")}
                    {...formik.getFieldProps("firstName")}
                  />
                </div>
                {formik.touched.firstName && formik.errors.firstName ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.firstName}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="lastName"
                    label="Last Name"
                    placeholder="Last Name"
                    className="w-100"
                    error={getInputClasses("lastName")}
                    {...formik.getFieldProps("lastName")}
                  />
                </div>
                {formik.touched.lastName && formik.errors.lastName ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.lastName}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="email"
                    label="Email"
                    placeholder="Email"
                    className="w-100"
                    error={getInputClasses("email")}
                    {...formik.getFieldProps("email")}
                  />
                </div>
                {formik.touched.email && formik.errors.email ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.email}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  {/* <TextField
                    id="phone"
                    label="Phone"
                    placeholder="Phone"
                    className="w-100"
                    error={getInputClasses("phone")}
                    {...formik.getFieldProps("phone")}
                  /> */}
                  <InputMask
                    mask="\9\94999999999"
                    {...formik.getFieldProps("phoneNumber")}
                    disabled={false}
                    maskChar=""
                    id="phoneNumber"
                    type="number"
                  >
                    {() =>
                      <TextField
                        label="Phone Number"
                        placeholder="Phone Number"
                        className="w-100"
                        name="phoneNumber"
                      // error={getInputClasses("cityPhoneNumber")}
                      />}
                  </InputMask>
                </div>
                {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.phoneNumber}</div>
                  </div>
                ) : null}
              </div>


              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="partnerId"
                    name="partnerId"
                    label="Partner id"
                    placeholder="Partner id"
                    className="w-100"
                    type="number"
                    hidden
                    error={getInputClasses("partnerId")}
                    {...formik.getFieldProps("partnerId")}
                  />

                  <ReactSelect
                    suggestions={partnersOptions}
                    handleChangeSingle={handleChangePartners}
                    single={partnersOption}
                    label="Choose partner"
                    placeholder="Choose partner"
                    inputId="partnerId"
                    error={getInputClasses("partnerId")}
                    {...formik.getFieldProps("partnerId")}
                  />
                  {/* <SelectAsyncPaginate
                    loadOptions={loadOptionsPartner}
                    onChange={handleChangePartners}
                    value={partnersOption}
                    label="Choose partner"
                    placeholder="Choose partner"
                    inputId="partnerId"
                  /> */}
                </div>
                {formik.touched.partnerId && formik.errors.partnerId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.partnerId}</div>
                  </div>
                ) : null}
              </div>


              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="partnerCityId"
                    name="partnerCityId"
                    label="City id"
                    placeholder="City id"
                    className="w-100"
                    type="number"
                    hidden
                    error={getInputClasses("partnerCityId")}
                    {...formik.getFieldProps("partnerCityId")}
                  />

                  <ReactSelect
                    suggestions={cities}
                    handleChangeSingle={handleChangeCities}
                    single={citiesOption}
                    label="Choose city"
                    placeholder="Choose city"
                    inputId="partnerCityId"
                    error={getInputClasses("partnerCityId")}
                    {...formik.getFieldProps("partnerCityId")}
                  />
                </div>

                {formik.touched.partnerCityId && formik.errors.partnerCityId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.partnerCityId}</div>
                  </div>
                ) : null}

                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div>


            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Close
          </Button>
          <Button type="submit">Create</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
